export default function truthy<T>(fields: (T | null | undefined | false)[]): T[] {
  return fields.filter((f) => !!f) as T[];
}
